.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.pes-tabs {
  width: 100%;
  background: #ffffff;
}

.pes-tabs--desktop-only {
  display: none;
}

@media screen and (min-width: 980px) {
  .pes-tabs--desktop-only {
    display: block;
  }
}

.pes-tabs .pes-tabs-hidden {
  display: none;
}

.pes-tabs .tab-primary a {
  font-weight: 400 !important;
  color: #626469 !important;
  font-size: 16px !important;
}

.pes-tabs .tab-primary a:not(.active) {
  border-top-width: 2px !important;
}

.pes-tabs .tab-primary a:hover, .pes-tabs .tab-primary a.active {
  color: #333333 !important;
  font-weight: 500 !important;
}

.pes-tabs .tab-primary nav[dir=rtl] a {
  border-left: 1px solid #e6e6e6 !important;
  border-right: 0 !important;
}

.pes-tabs .tab-primary nav[dir=rtl] a:first-child {
  border-right: 1px solid #e6e6e6 !important;
}

.pes-tabs__title {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

.pes-tabs-content {
  width: 100%;
}

.pes-tabs-content .pes-tabs-content-hidden {
  display: none;
}